export const UPDATE_USER = "@iweb/UPDATE_USER"
export const OFFER_REQUEST_CREATE = "@iweb/OFFER_REQUEST_CREATE"
export const OFFER_REQUEST_CREATED = "@iweb/OFFER_REQUEST_CREATED"
export const SET_DOER_PICK_STRATEGY = "@iweb/SET_DOER_PICK_STRATEGY"
export const SET_PROMOTION_DISABLED = "@iweb/SET_PROMOTION_DISABLED"
